import { defineNuxtPlugin, useHead } from '#imports';

// Resolved at runtime (not build time) so the same build artifact serves the
// right utag.js for whichever NUXT_PUBLIC_APPLICATION_ENV it's deployed with.
export default defineNuxtPlugin((nuxtApp) => {
  const trackingPixel =
    nuxtApp.$config.public.applicationEnv === 'production'
      ? nuxtApp.$config.tracking?.production
      : nuxtApp.$config.tracking?.dev;
  if (!trackingPixel) return;

  useHead({
    link: [{ rel: 'preload', href: trackingPixel, as: 'script' }],
    script: [{ src: trackingPixel, defer: true, tagPosition: 'bodyClose' }],
  });
});
